import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useEffect, useState, useContext } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../../App";
import PeriodFilterDates from "../../../components/PeriodFilterDates";
import { postMethod } from "../../../requests";
import { ReportsContext } from "./Reports";
import moment from "moment";

const InstructorsEfficiency = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const { checkServerData } = useContext(BasicContext);
    const [instrData, setInstrData] = useState(null);
    const { startDate, endDate } = useContext(ReportsContext);

    const getData = async () => {
        const res = await postMethod("/get-instr-efficiency", { startDate: moment(startDate).format("YYYY-MM-DD"), endDate: moment(endDate).format("YYYY-MM-DD") });
        if (checkServerData(res)) {
            setInstrData(res.data.data);
        }
        setLoading(false);
    };

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const filterDates = () => {
        setLoading(true);
        setTimeout(() => {
            getData();
        }, 500);
    };

    return (
        <Fragment>
            <Container fluid className="pt-3 bg-white">
                <Row>
                    <Col xs={12}>
                        <PeriodFilterDates filterDates={filterDates} />
                    </Col>
                    {loading ? (
                        <Col className="text-center">
                            <FontAwesomeIcon icon={faSpinner} className="rotate-center" />
                        </Col>
                    ) : (
                        <Fragment>
                            {instrData && (
                                <Fragment>
                                    <Col xs={12}>
                                        {instrData.length === 0 ? (
                                            <p className="opacity-75 fs-6 text-center">{t("noData")}</p>
                                        ) : (
                                            <Fragment>
                                                <Table className="white-table">
                                                    <tbody>
                                                        {instrData.map((e, i) => (
                                                            <Fragment key={i}>
                                                                <tr>
                                                                    <td colSpan={2} className="bold border-bottom-0 pb-0">
                                                                        {e.instructor_name} {e.instructor_surname}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-bottom-0 pb-0">
                                                                        {t("reports.instr.classNumber")}: {e.occurences}
                                                                    </td>
                                                                    <td className="text-end border-bottom-0 pb-0">
                                                                        {t("reports.instr.totalClassSlots")}: {e.total_class_slots}
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="border-bottom-0 pb-0">
                                                                        {t("reports.instr.availableClassNumber")}: {e.cnt_available_status}
                                                                    </td>
                                                                    <td className="text-end border-bottom-0 pb-0">
                                                                        {t("reports.instr.totalSigned")}: {e.total_cnt_signed}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-bottom-0 pb-0">
                                                                        {t("reports.instr.cancelledClassNumber")}: {e.cnt_cancelled_status}
                                                                    </td>
                                                                    <td className="text-end border-bottom-0 pb-0">
                                                                        {t("reports.instr.totalWaitlist")}: {e.total_cnt_waitlist}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td></td>
                                                                    <td className="text-end">
                                                                        {t("reports.instr.totalUnchecked")}: {e.total_cnt_unchecked}
                                                                    </td>
                                                                </tr>
                                                            </Fragment>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </Fragment>
                                        )}
                                    </Col>
                                </Fragment>
                            )}
                        </Fragment>
                    )}
                </Row>
            </Container>
        </Fragment>
    );
};

export default InstructorsEfficiency;
